// import preval from 'preval.macro';
// import React, { Fragment } from 'react';

// import packageJson from "../../../package.json";
// import { properties } from '../../constants/Propertise';

// class AppFooter extends React.Component {
//     render() {
//         return (
//             <Fragment>
//                 <div className="app-footer">
//                     <div className="app-footer__inner">
//                         <div className="app-footer-right">
//                             <ul className="nav">
//                                 <li className="nav-item">
//                                     <span className="nav-link">
//                                         © {new Date().getFullYear()} Tata Communications Transformation Services. All Rights Reserved.
//                                     </span>
//                                 </li>
//                             </ul>
//                         </div>
//                     </div>
//                 </div>
//                 {/* <div className='app-footer py-3 px-5 d-flex flex-column align-items-end bg-white'>
//                     <div>
//                         © 2020 - {new Date().getFullYear()} Tata Communications Transformation Services. All Rights Reserved.
//                         {properties.tataTagLine}
//                         <div className='d-flex justify-content-end'>
//                             {properties.NeoText}
//                         </div>
//                     </div>
//                     <div>
//                         {properties.appVersionText} {packageJson.version} {properties.buildDateText} - {getBuildDateString()}
//                     </div>
//                 </div> */}
//             </Fragment>
//         )
//     }
// }

// const getBuildDateString = () => {
//     const buildTimestamp = preval`module.exports = new Date()`;

//     const formattedDate = Intl.DateTimeFormat("en-US", {
//         year: "numeric",
//         month: "short",
//         day: "2-digit",
//         hour: "numeric",
//         minute: "numeric",
//         second: "numeric",
//     }).format(new Date(buildTimestamp));

//     return formattedDate;
// };

// export default AppFooter;

import preval from "preval.macro";
import React, { Fragment } from "react";

import packageJson from "../../../package.json";
import { properties } from "../../constants/Propertise";

class AppFooter extends React.Component {
  render() {
    return (
      <Fragment>
        {/* <div className="app-footer appmain">
                    <div className="app-footer__inner appmain">
                        <div className="app-footer-right appmain">
                            <ul className="nav">
                                <li className="nav-item">
                                    <span className="nav-link">
                                        © {new Date().getFullYear()} Tata Communications Transformation Services. All Rights Reserved.
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div> */}

        <div className="appmain app-footer d-flex flex-column align-items-end">
          <div
            className="appmain"
            style={{ paddingTop: "3%", paddingRight: "3%" }}
          >
            © 2020 - {new Date().getFullYear()} Tata Communications
            Transformation Services. All Rights Reserved.
            {/* {properties.tataTagLine}
                        <div className='d-flex justify-content-end'>
                            {properties.NeoText}
                        </div> */}
          </div>
          {/* <div className='appmain'>
                        {properties.appVersionText} {packageJson.version} {properties.buildDateText} - {getBuildDateString()}
                    </div> */}
        </div>
      </Fragment>
    );
  }
}

const getBuildDateString = () => {
  const buildTimestamp = preval`module.exports = new Date()`;

  const formattedDate = Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  }).format(new Date(buildTimestamp));

  return formattedDate;
};

export default AppFooter;
